'use strict'

module.exports = {
  kConstruct: require('../core/symbols').kConstruct
}
